import styled, { css } from 'styled-components';

import { ButtonWithRef } from 'components/button';

export const Text = styled.p<{ isRed?: boolean; isBold?: boolean }>`
  ${({ theme, isRed, isBold }) => css`
    color: ${isRed ? theme.config.text.red : theme.config.text.primary};

    ${isBold &&
    css`
      font-weight: 600;
    `}
  `}
`;

/** Positions the Pay spinner over the content (it never adds height). */
export const LoaderFrame = styled.div`
  position: relative;
  width: 100%;
`;

/** H2: "This paycheck changed since you opened it…", above the amounts. */
export const ChangedNotice = styled.p`
  ${({ theme }) => css`
    margin: 0;
    padding: 8px 12px;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: ${theme.config.text.primary};
    border: 1px solid rgba(193, 146, 3, 0.45);
    background: rgba(193, 146, 3, 0.1);
  `}
`;

export const AddRowButton = styled(ButtonWithRef)`
  margin-top: 8px;
  width: fit-content;
`;

export const PayoutAmountRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr minmax(0, 300px);
  gap: 8px;
  min-height: 40px;
`;

export const PayoutItemLabel = styled(Text)`
  margin: 0;
  font-weight: 600;
`;

export const PayoutItemControls = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;

  /* "Full amount" always shows in full; the input takes what is left. */
  & > button {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  & > button * {
    overflow: visible;
    white-space: nowrap;
    text-overflow: clip;
  }
`;

export const PayoutAmountInput = styled.input`
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  border: 1px solid ${({ theme }) => theme.config.input.border.default};
  border-radius: 6px;
  background: ${({ theme }) => theme.config.input.bg.default};
  color: ${({ theme }) => theme.config.input.text};
  font: inherit;

  &:focus {
    border-color: ${({ theme }) => theme.config.input.border.active};
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
  }
`;

export { SubRow, SubRows, SubAmount, SubActions } from './subrows';
